function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { generateRandomHex } from "./bytes";
const generateBotKey = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*() {
        return `sw_bot_${yield generateRandomHex()}`;
    });
    return function generateBotKey() {
        return _ref.apply(this, arguments);
    };
}();
const generateAPIKey = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(postfix) {
        return "pk_" + (postfix || "") + (yield generateRandomHex());
    });
    return function generateAPIKey(postfix) {
        return _ref.apply(this, arguments);
    };
}();
export const KeyGenerator = {
    bot: generateBotKey,
    publicAPI: generateAPIKey,
    privateAPI: generateAPIKey
};
